__turbopack_context__.v({
  "animated-loader-svg": "_5ZBgQW_animated-loader-svg",
  "spin": "_5ZBgQW_spin",
});
